// extracted by mini-css-extract-plugin
module.exports = {"btn-question":"index_btn-question_13yQS","rules-content":"index_rules-content_3dvaV"};